import React, { forwardRef, useContext } from 'react';
import classNames from 'classnames';
import StatisticNumber from './Number';
import Countdown from './Countdown';
import ConfigContext from '../config-provider/ConfigContext';
const Statistic = forwardRef(function Statistic(props, _ref) {
    const { prefixCls: customizePrefixCls, className, style, valueStyle, value = 0, title, valueRender, prefix, suffix, onMouseEnter, onMouseLeave, } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('statistic', customizePrefixCls);
    const valueNode = React.createElement(StatisticNumber, Object.assign({}, props, { prefixCls: prefixCls, value: value }));
    const cls = classNames(prefixCls, className);
    return (React.createElement("div", { className: cls, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        title && React.createElement("div", { className: `${prefixCls}-title` }, title),
        React.createElement("div", { style: valueStyle, className: `${prefixCls}-content` },
            prefix && React.createElement("span", { className: `${prefixCls}-content-prefix` }, prefix),
            valueRender ? valueRender(valueNode) : valueNode,
            suffix && React.createElement("span", { className: `${prefixCls}-content-suffix` }, suffix))));
});
Statistic.displayName = 'Statistic';
Statistic.defaultProps = {
    decimalSeparator: '.',
    groupSeparator: ',',
};
Statistic.Countdown = Countdown;
export default Statistic;
